import { c as _c } from "react/compiler-runtime";
import React from 'react';
import useProductListingPageContext from 'data-hooks/useProductListingPageContext';
import MobileProductListingFilter from './MobileProductListingFilter';

// On mobile, we want to show the quickship filter at the top, the color filter
// at the bottom, and we should not show the search filter at all.
const getFiltersInMobileOrder = filters => {
  const quickshipFilter = filters.find(({
    id
  }) => id === 'quickship');
  const colorFilter = filters.find(({
    id
  }) => id === 'color');
  const widthRangeFilter = filters.find(({
    id
  }) => id === 'widthRange');
  const filtersWithoutQuickshipColorSearchAndWidthRange = filters.filter(filter => !['quickship', 'color', 'search', 'widthRange'].includes(filter.id));
  const orderedFilters = [quickshipFilter, widthRangeFilter, ...filtersWithoutQuickshipColorSearchAndWidthRange, colorFilter].filter(filter => !!filter);
  return orderedFilters;
};
const MobileProductListingFilters = () => {
  const $ = _c(4);
  const {
    filters: t0
  } = useProductListingPageContext();
  let t1;
  if ($[0] !== t0) {
    const filters = t0 === undefined ? [] : t0;
    const orderedFilters = getFiltersInMobileOrder(filters);
    t1 = orderedFilters.map(_temp);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div>{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default MobileProductListingFilters;
function _temp(t0) {
  const {
    id,
    label
  } = t0;
  return <MobileProductListingFilter id={id} key={id} label={label} />;
}